var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3.8 0 76.76 76.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target_hit_aim",
    "data-name": "target hit aim",
    transform: "translate(-1472.649 -50.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M1541.8,92.34a34.576,34.576,0,1,1-34.574-34.583A34.572,34.572,0,0,1,1541.8,92.34Z",
    fill: "#f44b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M1532.648,92.34a25.425,25.425,0,1,1-25.42-25.432A25.431,25.431,0,0,1,1532.648,92.34Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M1523.135,92.34a15.907,15.907,0,1,1-15.907-15.91A15.9,15.9,0,0,1,1523.135,92.34Z",
    fill: "#f44b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1514.365,92.34a7.141,7.141,0,1,1-7.137-7.138A7.144,7.144,0,0,1,1514.365,92.34Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M1508.356,92.924a1.478,1.478,0,1,1-2.682-1.244L1522.2,56.27a1.483,1.483,0,1,1,2.688,1.251Z",
    fill: "#163844"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M1521.954,56.841l-2.432-6.694-6.041,12.936,2.427,6.691Z",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M1525.255,68.586l-6.682,2.422,6.031-12.935,6.676-2.429Z",
    fill: "#27b7ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.102caf9dc0f7886f0c20a13d6b8ec2b6.svg";
export { ForwardRef as ReactComponent };